import { render, staticRenderFns } from "./ReferencePicker.vue?vue&type=template&id=fcee4fac&scoped=true&"
import script from "./ReferencePicker.vue?vue&type=script&lang=ts&"
export * from "./ReferencePicker.vue?vue&type=script&lang=ts&"
import style0 from "./ReferencePicker.vue?vue&type=style&index=0&id=fcee4fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcee4fac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
